<div
  class="expandable-copy-wrapper"
  #copyWrapper
  [class.show-less]="!showAll"
  [class.show-all]="showAll || !isExpandable"
  [innerHTML]="text"
></div>
@if (isExpandable) {
  <div class="expandable-copy-btn-wrapper">
    <div class="btn btn-secondary" (click)="showAll = !showAll">
      @if (showAll) {
        <span>{{ 'LESS' | translate }}</span>
      }
      @if (!showAll) {
        <span>{{ 'MORE' | translate }}</span>
      }
    </div>
  </div>
}
